import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from '@mui/material';
import classes from 'app/components/BarChart/styles.scss';
const BarChart = ({ elements, showLegend, style }) => {
    const total = elements.reduce((acc, el) => acc + el.value, 0);
    return (_jsx("div", { className: classes.barChart, children: elements.map((el) => {
            const percent = (el.value / total) * 100;
            return (_jsxs("div", { style: Object.assign(Object.assign({}, style), { width: percent + '%', height: '100%', textAlign: 'center' }), children: [_jsx(Tooltip, { title: el.name, children: _jsx("div", { style: {
                                height: '100%',
                                width: '100%',
                                backgroundColor: el.color,
                            } }) }), showLegend ? _jsx("span", { className: classes.legend, children: el.value }) : null] }, el.name));
        }) }));
};
export default BarChart;
